export const COLUMNS_TO_FILTER = [
	{ data: 'id', label: 'Id' },
	{ data: 'seller', label: 'Seller' },
	{ data: 'cost_date', label: 'Cost Date' },
	{
		data: 'sku',
		label: 'SKU',
	},
	{
		data: 'cost_type',
		label: 'Cost Type',
	},
	{
		data: 'usd_cost',
		label: 'USD Cost',
	},
	{
		data: 'quote',
		label: 'Quote',
	},
	{ data: 'local_currency_cost', label: 'Local Currency Cost' },
	{
		data: 'purchase_order',
		label: 'Purchase Order',
	},
	{
		data: 'shipment',
		label: 'Shipment',
	},
	{ data: 'category_owner', label: 'Category owner' },
	{
		data: 'product_type',
		label: 'Product Type',
	},
];

export const INITIAL_COLUMNS_STATE = {
	id: true,
	seller: true,
	cost_date: true,
	sku: true,
	cost_type: true,
	usd_cost: true,
	quote: true,
	local_currency_cost: true,
	purchase_order: true,
	shipment: true,
	category_owner: true,
	product_type: true,
};

export const OPERATOR_TO_FILTER = [
	{
		id: 1,
		name: 'between',
		label: 'Between',
	},
];

export const INITIAL_OPERATOR_STATE = {
	between: true,
};
